import { createReducer } from '@reduxjs/toolkit';

let price = 0;
const gold_sell_price = createReducer(price, {
  update_sell_price: (state, action) => {
    return action.payload;
  },
});

export default gold_sell_price;
